<ion-header class="ion-no-border chat-header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>

    <ion-title class="chat-title">
      <div class="user-info" *ngIf="chatData?.userName">
        <ion-avatar>
          <img [src]="chatData?.userImage || 'assets/imgs/default-avatar.png'" alt="User">
        </ion-avatar>
        <div class="user-details">
          <h2>{{ chatData?.userName || 'Chat' }}</h2>
          <p class="status">Online</p>
        </div>
      </div>
      <span *ngIf="!chatData?.userName">Chat</span>
    </ion-title>

    <ion-buttons slot="end">
      <ion-button color="primary">
        <ion-icon name="call" slot="icon-only"></ion-icon>
      </ion-button>
      <ion-button (click)="closeChat()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="chat-content">
  <!-- Loading state -->
  <div class="loading-container" *ngIf="isLoading">
    <ion-spinner name="bubbles"></ion-spinner>
    <p>{{ 'LOADING_MESSAGES' | translate }}</p>
  </div>

  <!-- Empty state -->
  <div class="empty-chat" *ngIf="hasNoData && !isLoading">
    <ion-img src="../../../assets/imgs/chat.svg"></ion-img>
    <h2>{{ 'WE_RESPOND_IMMEDIATELY' | translate }}</h2>
    <p>{{ 'TELL_US_HOW_WE_CAN_HELP' | translate }}</p>
  </div>

  <!-- Messages -->
  <div class="messages-container" *ngIf="!isLoading && !hasNoData">
    <div class="message-wrapper" *ngFor="let message of messages | async"
      [ngClass]="{'my-message': message.myMsg, 'other-message': !message.myMsg}">

      <div class="message-bubble" [ngClass]="{'media-bubble': message.type !== 'text'}">
        <div class="message-info" *ngIf="!message.myMsg">
          <span class="sender-name">{{ message.fromName }}</span>
        </div>

        <!-- Text Message -->
        <div class="message-content" *ngIf="message.type === 'text' || !message.type">{{ message.msg }}</div>

        <!-- Image Message -->
        <div class="media-content image-msg" *ngIf="message.type === 'image'">
          <img [src]="message.mediaUrl" (click)="viewMedia(message.mediaUrl, 'image')">
        </div>

        <!-- Video Message -->
        <div class="media-content video-msg" *ngIf="message.type === 'video'">
          <video [src]="message.mediaUrl" controls></video>
        </div>

        <!-- Audio Message -->
        <div class="media-content audio-msg" *ngIf="message.type === 'audio'">
          <div class="audio-player">
            <ion-button fill="clear" (click)="playAudio(message.mediaUrl)">
              <ion-icon name="play-circle" size="large"></ion-icon>
            </ion-button>
            <div class="audio-wave">Voicenote</div>
          </div>
        </div>

        <div class="message-time">{{ formatTime(message.createdAt) }}</div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="chat-footer">
  <ion-toolbar>
    <div class="input-container">
      <ion-button class="attach-button" fill="clear" (click)="presentAttachmentOptions()">
        <ion-icon name="add-circle-outline"></ion-icon>
      </ion-button>

      <ion-textarea class="message-input" placeholder="{{ 'TYPE_MESSAGE' | translate }}" rows="1" autosize
        [(ngModel)]="newMsg" (ionFocus)="Show()" (ionBlur)="Hide()" autoGrow="true">
      </ion-textarea>

      <ion-button class="send-button" [disabled]="!newMsg.trim() || isTyping" (click)="sendMessage()">
        <ion-icon *ngIf="!isTyping" name="send"></ion-icon>
        <ion-spinner *ngIf="isTyping" name="dots" class="send-spinner"></ion-spinner>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>